export const FETCH_COMMENTS_BY_RESOURCE_ID = 'fetchCommentsByResourceId';
export const CREATE_COMMENT = 'createComment';
